export default function PromptCards({ onPromptSelect, showCards = true }) {
  if (!showCards) return null

  const prompts = [
    {
      title: "Inspect water heater",
      description: "Check efficiency",
      text: "Inspect water heater efficiency"
    },
    {
      title: "Analyze HVAC",
      description: "Performance check", 
      text: "Analyze HVAC system"
    },
    {
      title: "Check plumbing",
      description: "Detect leaks",
      text: "Check plumbing leaks"
    },
    {
      title: "Electrical safety",
      description: "Panel check",
      text: "Electrical safety check"
    }
  ]

  return (
    <div className="mb-4">
      <div className="flex gap-3 overflow-x-auto pb-2 no-scrollbar">
        {prompts.map((prompt, index) => (
          <button
            key={index}
            onClick={() => onPromptSelect(prompt.text)}
            className="min-w-[160px] p-3 text-left border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors flex-shrink-0"
          >
            <div className="font-medium text-gray-900 text-sm">{prompt.title}</div>
            <div className="text-xs text-gray-600 mt-1">{prompt.description}</div>
          </button>
        ))}
      </div>
    </div>
  )
}
